import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-exg-kpi-progressbar',
  templateUrl: './exg-kpi-progressbar.component.html',
  styles: [
  ]
})
export class ExgKpiProgressbarComponent implements OnInit {


  @Input() caption: string = 'Caption';
  @Input() value: number = 0.75;
  @Input() color: string = '#56ab2f';
   constructor() { }

  ngOnInit(): void {
  }
  get barstyle(): string {
    return `width: calc(${this.value} * 100%); background: linear-gradient(to right, ${this.color},  ${this.color});`;
  }
  get labelstyle(): string {
     if (this.value > 0.51) { return 'color: var(--c-light-m5);';}
     return 'color: var(--c-dark-m5);';
  }

}
